import UploadImagePage from './pages/UploadImagePage';

function UploadInvoice({ onBackToDashboard }) {
  return <UploadImagePage onBackToDashboard={onBackToDashboard} />;
}

export default UploadInvoice;
